<template>
  <div class="newbie-activity-dialog">
    <div class="newbie-activity-content" slot="custom" >
      <nd-button class="button get-money" @click="getMoney" >马上拿钱</nd-button>
      <div class="button act-detail" @click="toActivityDetail">活动详情 ></div>
    </div>
  </div>
</template>

<script>
import { setKey } from '../../../../assets/utils'

export default {
  data () {
    return {
      visible: true
    }
  },
  props: {
    caseId: {
      type: [String, Number],
      default: ''
    },
    data: {
      type: Object,
      default: () => ({})
    },
    isLogin: Boolean
  },
  methods: {
    open () {
      this.visible = true
      setKey('NEWBIE_ACTIVITY_SHOW_TIME', Date.now())
    },
    close () {
      this.visible = false
      this.$$emit('close')
    },
    // 马上拿钱
    getMoney () {
      this.$router.push('/middle/limit')
      this.close()
    },
    // 活动详情
    toActivityDetail () {
      this.$router.push('/unauthedNewbie/detail')
    },
    show () {
      this.isLogin && setKey('NEWBIE_ACTIVITY_SHOW_TIME', Date.now())
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.newbie-activity-dialog {
  .newbie-activity-content {
    width: 620px;
    height: 750px;
    background: url("./images/home_newbie_act_pop_c.png") no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    .button {
      width: 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      font-family: PingFangSC-Semibold, PingFang SC;
      color: #FFFFFF;
      &.get-money {
        top: 540px;
        width: 440px;
        height: 80px;
        font-size: 36px;
        font-weight: 600;
        line-height: 50px;
      }
      &.act-detail {
        top: 657px;
        height: 80px;
        font-size: 28px;
        font-weight: 400;
        line-height: 40px;
        text-align: center;
      }
    }
  }
}
</style>